export default __webpack_public_path__ + "static/media/TonicKnowledge.9d8fedfde4304edc32262e20a1f59cb1.webp";